//
// BIRDModelController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/BIRDModel";
import "./ReportController";

var BIRDModelController = createModule("BIRD::BIRDModelController", [], EventDispatcher, [
    {
        CONTENT_COMPLETE: 50002,
        CONTENT_COMPLETE_RESET: 50003,
        DATA_REFRESH_TRIGGERED: 50005,
        CONTENT_PROGRESS: 50004,
    },
    ,
    ,
    ,
    {
        redispatchContentComplete: [0],
        endSequence: [0],
        getBIRDModel: [1],
        getReportController: [1],
        isContentComplete: [2],
        refreshData: [0],
        beginSequence: [0],
    },
    ,
    ,
]);
export default BIRDModelController;
